export default __webpack_public_path__ + "static/media/ahsoka_002.fb8c2f2d.jpeg";